 const Loaders = () => {
  return (
    <>
     <div className={"sweet-loading h-[100vh] w-[100vw] fixed inset-[0] z-[999]"}>
        <img src="/images/Loaderanim.png" alt="loader" className="fixed inset-[0px] m-auto animate-spin" />
      </div>
    </>
  );
  
};

export default Loaders;
